import { Bluesky, Facebook, Instagram, Tiktok, YouTube } from '@byway/icons';

// Supported social platforms: tech owned.
// a new CMS `platform` value needs a by-icons addition here before it can render.
export const socialMediaIcons = {
  bluesky: Bluesky,
  facebook: Facebook,
  instagram: Instagram,
  tiktok: Tiktok,
  youtube: YouTube
} as const;

export type SocialPlatform = keyof typeof socialMediaIcons;

export const toSocialPlatform = (platform: string): SocialPlatform | null => {
  const key = platform.toLowerCase();
  return key in socialMediaIcons ? (key as SocialPlatform) : null;
};
